var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transactions-icon copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-759.000000, -392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "29)-Widgets/3)-Statistics/9)-Sales-2-Copy-5",
    transform: "translate(746.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Growth--Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transactions-icon-copy-4",
    transform: "translate(13.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style",
    opacity: 0,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#F6931E",
    opacity: 0.159999996,
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-employee-1995003",
    transform: "translate(10.000000, 9.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4962406,6.42105263 C16.4962406,9.96734023 14.0339286,12.8421053 10.9962406,12.8421053 C7.95855263,12.8421053 5.4962406,9.96729323 5.4962406,6.42105263 C5.4962406,2.87481203 7.95855263,0 10.9962406,0 C14.0339286,0 16.4962406,2.87481203 16.4962406,6.42105263",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9962406,14.1578947 L15.2594925,12.9210526 C14.0753289,13.9210996 12.575235,14.500094 10.9963816,14.500094 C9.39111842,14.500094 7.91743421,13.9211466 6.73327068,12.9210526 L3.99652256,14.1578947 C1.57514098,15.2367011 0.022556391,17.6578947 0.022556391,20.3157895 L0.022556391,22.5262688 C0.022556391,23.8947368 1.12781955,25 2.49628759,25 L19.4962876,25 C20.8647556,25 21.9700188,23.8947368 21.9700188,22.5262688 L21.9700188,20.3157895 C21.9700188,17.6579417 20.4172462,15.2368421 17.9962406,14.1578947 L17.9962406,14.1578947 Z M17.2067199,19.4736842 C17.2067199,19.657984 17.0751034,19.7894173 16.8909868,19.7894173 L14.0751034,19.7896008 C13.8908036,19.7896008 13.7593703,19.6579843 13.7593703,19.4738678 L13.7593703,18.6581253 C13.7593703,18.4738255 13.8909868,18.3423922 14.0751034,18.3423922 L16.8909868,18.3423922 C17.0752867,18.3423922 17.2067199,18.4740087 17.2067199,18.6581253 L17.2067199,19.4736842 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoscount);
export default __webpack_public_path__ + "static/media/Pos count.9d3c870e07fb70884adf6383b7ec3bc6.svg";
export { ForwardRef as ReactComponent };